import { get } from 'lodash'
import { Component } from 'react'
import styled, { css } from 'styled-components'

import FactText from './FactText'
import withSpacing from './WithSpacing'

const StyledFactSetTitleContainer = styled.td`
  flex: 0;
  max-width: ${(props: any) => get(props.theme, 'factSet.title.maxWidth')}px;
`

const StyledFactSetValueContainer = styled.td`
  flex: 1;
  padding-left: ${(props: any) => get(props.theme, 'factSet.spacing', 5)}px;
  ${(props: any) =>
    get(props.theme, 'factSet.value.maxWidth') &&
    css`
      max-width: ${(props: any) => get(props.theme, 'factSet.value.maxWidth')}px;
    `};
`

const StyledFactSetRow = styled.tr`
  vertical-align: top;
`

interface FactSetProps {
  facts?: {
    title: string
    value: string
  }[]
  separation?: 'default' | 'none' | 'strong'
}

class FactSet extends Component<FactSetProps> {
  static displayName = 'FactSet'
  static defaultProps = {
    facts: [{ title: '', value: '' }]
  }

  render() {
    return (
      <table>
        <tbody>
          {/* @ts-expect-error */}
          {this.props.facts.map((fact: any, factIndex: any) => (
            <StyledFactSetRow key={factIndex}>
              <StyledFactSetTitleContainer>
                <FactText type="title" text={fact.title} />
              </StyledFactSetTitleContainer>
              <StyledFactSetValueContainer>
                <FactText type="value" text={fact.value} />
              </StyledFactSetValueContainer>
            </StyledFactSetRow>
          ))}
        </tbody>
      </table>
    )
  }
}

const ACFactSetWithSeparation = withSpacing(FactSet)

export default ACFactSetWithSeparation
